<template>
  <div
    v-if="!loadingInitialApiData && !printerFriendly"
    id="divLogiSelector"
    class="LogiSelector">
    <div class="container-fluid filterContainer">
      <div class="row rd-gridsystem-scrollbar-wrap">
        <div class="rdResponsiveColumn col-lg-2 col-md-2 col-sm-2 col-xs-12">
          <div class="padTopSelect">
            <label
              for="islLocation"
              class="rdThemeInputCaption">Location</label>
            <select
              id="islLocation"
              v-model="GS.locationId"
              class="rdThemeInput"
            >
              <option
                v-for="item in locations"
                :value="item.id"
                :key="'L' + item.id">
                {{ item.name }}</option>
            </select>
            <span
              v-if="showDebugIds"
              class="debugIds"
            >
              {{ GS.locationId }} count: {{ locations.length }}</span>
          </div>
        </div>
        <div class="rdResponsiveColumn col-lg-2 col-md-2 col-sm-2 col-xs-12">
          <div class="padTopSelect">
            <label
              for="islCategory"
              class="rdThemeInputCaption">Category</label>
            <select
              id="islCategory"
              v-model="GS.categoryId"
              class="rdThemeInput"
            >
              <option
                v-for="item in categories"
                :value="item.id"
                :key="item.id">{{ item.name }}</option>
            </select>
            <span
              v-if="showDebugIds"
              class="debugIds"
            >{{ GS.categoryId }} Count: {{ categories.length }}</span>
          </div>
        </div>
        <div class="rdResponsiveColumn col-lg-1 col-md-2 col-sm-2 col-xs-12">
          <div class="padTopGo">
            <div id="divGoBtn">
              <input
                :class="{ButtonDisabled: !goEnabled}"
                type="button"
                value="GO"
                class="span2"
                @click="goButtonClicked">
            </div>
          </div>
        </div>
      </div>
    </div>
</div></template>

<script>
/* global triggerOmnitureInteractions */
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';
import helper from '../../helper';

export default {
  data() {
    return {
      GS: {
        locationId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'LocationId'),
        categoryId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'CategoryId'),
      },
    };
  },
  computed: {
    ...mapState({
      gsLink: state => state.spgsLink,
      lku: state => state.lku,
      loadingInitialApiData: state => state.flags.loadingInitialApiData,
      initialPageLoad: state => state.flags.initialPageLoad,
      showDebugIds: state => state.flags.showDebugIds,
      GSGo: state => state.SP.GSGo,
    }),
    ...mapGetters([
      'printerFriendly',
    ]),
    locations() {
      return helper.addSelectOne(_(this.gsLink).map('l').uniq()
      // eslint-disable-next-line
        .map(id => {
          // eslint-disable-next-line
          if (this !== undefined)
            return this.lku.Location[id];
        })
        .orderBy('sort', 'asc')
        .filter(item => item !== undefined)
        .value());
    },
    categories() {
      return helper.addSelectOne(_(this.gsLink).filter({ l: this.GS.locationId }).map('c').uniq()
        .map(id => this.lku.Category[id])
        .orderBy('sort', 'asc')
        .value());
    },
    goEnabled() {
      return this.gsLink.length
            && this.GS.locationId
            && this.GS.categoryId;
    },
  },
  watch: {
    locations() {
      this.GS.locationId = helper.defaultOrFirstId(
        this.locations,
        this.GS.locationId,
        true,
      );
    },
    categories() {
      this.GS.categoryId = helper.defaultOrFirstId(
        this.categories,
        this.GS.categoryId,
        true,
      );
    },
    loadingInitialApiData() {
      if (!this.loadingInitialApiData) {
        // initial api data is loaded
        // When the app is started on the SP route, the created
        // event fires before the initial api data is loaded. This watch
        // auto clicks the Go button when the initial api data load completes.
        this.autoClickGoButtonIfInitialPageLoad();
      }
    },
  },
  created() {
    // initialize the GS state from the previous GSGo state from the SP store
    // if not initial page load
    if (!this.initialPageLoad) {
      this.GS.locationId = this.GSGo.locationId;
      this.GS.categoryId = this.GSGo.categoryId;
    }
    // Auto click Go if loadingInitialApiData has completed before the created event.
    if (!this.loadingInitialApiData) {
      this.autoClickGoButtonIfInitialPageLoad();
    }
  },
  methods: {
    getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey) {
      return this.$store.getters
        .getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey);
    },
    goButtonClicked() {
      if (this.goEnabled) {
        // capture current global selector state into state.SP.GSGo
        const payload = this.GS;
        payload.location = this.lku.Location[this.GS.locationId].name;
        payload.category = this.lku.Category[this.GS.categoryId].name;
        triggerOmnitureInteractions(`${process.env.InteractionIdentifier}-LS ${this.GS.locationId},${this.GS.categoryId}`);
        this.$store.commit('SP/setGSGo', payload);
        this.$store.commit('SP/setShowHeadingsAndFilters', true);
      }
    },
    autoClickGoButtonIfInitialPageLoad() {
      if (this.initialPageLoad && this.goEnabled) {
        this.goButtonClicked();
      } else if (this.initialPageLoad && !this.goEnabled) {
        // Clear initial page load if go is not enabled.
        // This prevents extraneous LY interactions from being triggered the first time the GO button is clicked.
        this.$store.commit('setInitialPageLoad', false);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SP/SPGlobalSelector.vue